import React, { useState, useEffect } from "react";
import styled from "styled-components";
import colors from "../common/Color";
import { Root, Logo, Header } from "../common/FormHeader";
import { sendEmailConfirm } from "../actions/action";
import { getAllIdentity } from "../actions/action";
import Title from "../common/Title";
import { ReactComponent as EmailIcon } from "../assets/Icons/ic_mail 3.svg";
import WebButton from "../common/WebButton";
import ErrorModal from "../common/ErrorModal";
import Snackbar from "@material-ui/core/Snackbar";
import Button from "@material-ui/core/Button";

const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 500px) {
    width: 100vw;
    margin: 2rem 5vw 0 5vw;
  }
`;
const FlexCenter = styled.div`
  display: flex;
  justify-content: center;
`;
const StyledTitle = styled(Title)`
  && {
    text-align: center;
    margin-bottom: 1rem;
  }
`;
const EmailIc = styled(EmailIcon)`
  width: 9rem;
  height: 6.65rem;
  margin: 2rem 0;
  @media (max-width: 1024px) {
    width: 8rem;
    height: 5.91rem;
  }
`;
const Text = styled.div`
  font-family: "Sarabun-Regular";
  font-size: 1rem;
  color: ${props => (props.email ? colors.primary : "rgba(0,0,0,0.6)")};
  letter-spacing: 0.03rem;
  line-height: 1.75rem;
  text-align: center;
`;
const TextDiv = styled.div`
  margin: 0 auto;
`;
const EmailDiv = styled.div`
  display: flex;
  justify-content: center;
  @media (max-width: 500px) {
    display: block;
  }
`;
const Btn = styled(WebButton)`
  && {
    width: 24rem;
    height: 2.75rem;
    margin-top: 2rem;
    @media (max-width: 500px) {
      width: 100%;
    }
  }
`;
const SendAgainDiv = styled.div`
  margin-top: 1.5rem;
  display: flex;
  @media (max-width: 1025px) {
    margin-bottom: 6rem;
  }
`;
const SendAgainTxt = styled.a`
  font-family: "Sarabun-Regular";
  font-size: 16px;
  color: ${props => (props.primary ? colors.primary : "rgba(0,0,0,0.6)")};
  letter-spacing: 0.03rem;
  text-align: center;
  line-height: 1.75rem;
  cursor: ${props => (props.primary ? "pointer" : "auto")};
  text-decoration: none;
`;
export default function PleaseConfirmPage(props) {
  const [userData, setUserData] = useState({});
  const [errorOpen, setErrorOpen] = useState(false);
  const [textMessage, setTextMessage] = useState("");
  const [openSnack, setOpenSnack] = useState(false);
  const { userId } = props;

  const handleErrorClose = () => {
    setErrorOpen(false);
  };

  const handleCloseSnackbar = () => {
    setOpenSnack(false);
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await getAllIdentity(userId[0]);
        if (res.status === 200) {
          setUserData(res.data);
        }
      } catch (err) {
        console.log(err);
      }
    }
    fetchData();
    // eslint-disable-next-line
  }, []);

  const InboxPath = email => {
    if (email.search("@gmail.") > 1) {
      return "https://mail.google.com/mail/u/0/#inbox";
    } else if (email.search("@hotmail.") > 1 || email.search("@outlook.") > 1) {
      return "https://outlook.live.com/mail/0/inbox";
    } else if (email.search("@yahoo.") > 1) {
      return "https://mail.yahoo.com";
    } else {
      return "https://mail.google.com/mail/u/0/#inbox";
    }
  };

  async function sendEmailAgain() {
    try {
      const res = await sendEmailConfirm(userId[0]);
      if (res.status === 200) {
        setOpenSnack(true);
      }
    } catch (err) {
      if (err.response) {
        if (err.response.status === 400) {
          setTextMessage(err.response.data);
          setErrorOpen(true);
        }
      }
      console.log(err);
    }
  }

  return (
    <div id="root">
      <ErrorModal
        id="err-modal"
        textMessage={textMessage}
        handleErrorClose={handleErrorClose}
        errorOpen={errorOpen}
      />
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={openSnack}
        onClose={handleCloseSnackbar}
        message="อีเมลถูกส่งแล้ว"
        action={
          <Button color="secondary" size="small" onClick={handleCloseSnackbar}>
            X
          </Button>
        }
      />
      <Root id="root-header">
        <Header id="header">
          <Logo id="logo" />
        </Header>
      </Root>
      <FlexCenter id="flex-center">
        <Container id="container">
          <EmailIc id="email-ic" />
          <StyledTitle id="title">กรุณายืนยันอีเมล</StyledTitle>
          <TextDiv id="content">
            <EmailDiv id="email-div">
              <Text id="txt">เราได้ส่งลิงก์ยืนยันอีเมลไปที่ &nbsp;</Text>
              <Text id="txt" email="true">
                {userData.email ? userData.email.data : ""} &nbsp;
              </Text>
            </EmailDiv>
            <Text id="txt">แล้วกรุณาตรวจสอบกล่องข้อความของคุณ</Text>
          </TextDiv>
          <Btn
            id="btn"
            primary="true"
            href={InboxPath(userData.email ? userData.email.data : "")}
            target="_blank"
            rel="noopener noreferrer"
          >
            เปิดกล่องข้อความ
          </Btn>
          <SendAgainDiv id="sendagain-div">
            <SendAgainTxt id="sendagain-txt">
              ไม่ได้รับอีเมล? &nbsp;
            </SendAgainTxt>
            <SendAgainTxt
              id="sendagain-txt-primary"
              primary
              onClick={sendEmailAgain}
            >
              ส่งอีเมลอีกครั้ง
            </SendAgainTxt>
          </SendAgainDiv>
        </Container>
      </FlexCenter>
    </div>
  );
}
